import './styles/main.css';
import {AppManagerBillingPage} from './app-manager-billing-page.js';
import {PlanCardSlider} from './components/custom/plan-card-slider.js';
import {PlanTable} from './components/custom/plan-table.js';
import {AppButton} from './components/custom/button.js';
import {FaqAccordion} from "@/components/custom/faq-accordion.js";

import {AppManagerBillingPagePolaris} from "./app-manager-billing-page-polaris.js";
import {PlanCardSliderPolaris} from "./components/polaris/plan-card-slider.js";
import {PlanTablePolaris} from "./components/polaris/plan-table.js";

// --- Expose SDK Version ---
if (typeof window !== 'undefined') {
    window.AppManager = window.AppManager || {};
    window.AppManager.version = __APP_MANAGER_VERSION__;
}

export const VERSION = __APP_MANAGER_VERSION__;

export async function init({autoRegister = true} = {}) {
    if (autoRegister) {
        if (!customElements.get('app-manager-billing-page')) {
            customElements.define('app-manager-billing-page', AppManagerBillingPage);
        }
        if (!customElements.get('plan-card-slider')) {
            customElements.define('plan-card-slider', PlanCardSlider);
        }
        if (!customElements.get('plan-table')) {
            customElements.define('plan-table', PlanTable);
        }
        if (!customElements.get('app-button')) {
            customElements.define('app-button', AppButton);
        }
        if (!customElements.get('app-manager-billing-page-polaris')) {
            customElements.define('app-manager-billing-page-polaris', AppManagerBillingPagePolaris);
        }
        if (!customElements.get('plan-card-slider-polaris')) {
            customElements.define('plan-card-slider-polaris', PlanCardSliderPolaris);
        }
        if (!customElements.get('plan-table-polaris')) {
            customElements.define('plan-table-polaris', PlanTablePolaris);
        }
        if (!customElements.get('faq-accordion')) {
            customElements.define('faq-accordion', FaqAccordion);
        }
    }
}

export {
    AppManagerBillingPage,
    PlanCardSlider,
    PlanTable,
    AppButton,
    FaqAccordion,
    AppManagerBillingPagePolaris,
    PlanCardSliderPolaris,
    PlanTablePolaris
};
